var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefreshGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.727 3.273l-3.273 3.272h2.455c0 2.709-2.2 4.91-4.909 4.91a4.803 4.803 0 01-2.29-.573l-1.195 1.194A6.49 6.49 0 009 13.091a6.544 6.544 0 006.546-6.546H18l-3.273-3.272zM4.091 6.545c0-2.708 2.2-4.909 4.909-4.909.826 0 1.612.205 2.29.573l1.196-1.194A6.49 6.49 0 009 0a6.544 6.544 0 00-6.545 6.545H0l3.273 3.273 3.272-3.273H4.091z",
    fill: "#98B9D5"
  })));
}
export default SvgIconRefreshGray;